import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Check if this is an OAuth authorization request (SSO from external app)
                    const hasOAuthParams = routeTo.query.client_id && routeTo.query.redirect_uri;
                    
                    if (hasOAuthParams) {
                        // Redirect to OAuth authorize page instead of home
                        next({ 
                            name: 'sso-authorize',
                            query: routeTo.query // Preserve all query parameters
                        });
                    } else {
                        // Normal case: redirect to home
                        next({ name: 'home' });
                    }
                } else {
                    // User not logged in, continue to login page
                    next();
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/reset-password',
        name: 'Reset-password',
        component: () => import('../views/pages/account/reset-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('../views/pages/account/logout.vue'),
        meta: {
            authRequired: false, // Allow unauthenticated access (for SSO logout from external sites)
            beforeResolve(routeTo, routeFrom, next) {
                // Just navigate to the logout component, it will handle the logout flow
                next();
            },
        },
    },
    {
        path: '/sso-authorize',
        name: 'sso-authorize',
        component: () => import('../views/pages/account/sso-authorize.vue'),
        meta: {
            authRequired: false, // We'll check auth inside the component
            beforeResolve(routeTo, routeFrom, next) {
                // Just navigate to the sso-authorize component, it will handle the OAuth flow
                next();
            },
        },
    },
    {
        path: '/collaborators/register',
        name: 'collaborators-register',
        component: () => import('../views/pages/collaborators/register/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/stores',
        name: 'stores',
        meta: {
            authRequired: true,
            permission:"menuitem.show"
        },
        component: () => import('../views/pages/stores/stores')
    },
    {
        path: '/orders',
        name: 'orders',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/orders/orders')
    },
    {
        path: '/customers',
        name: 'customers',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/customers/customers')
    },
    {
        path: '/notifications',
        name: 'notifications',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/notifications/notifications')
    },
    {
        path: '/collaborators',
        name: 'collaborators',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/collaborators/collaborators')
    },
    {
        path: '/card-applications',
        name: 'card-applications',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/card-applications/card-applications')
    },
    {
        path: '/holders',
        name: 'holders',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/holders/holders')
    },
    {
        path: '/products',
        name: 'products',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/products/products'),
    },
    {
        path: '/promotions',
        name: 'promotions',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/promotions/promotions'),
    },
    {
        path: '/raffles',
        name: 'raffles',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/raffles/raffles'),
    },
    {
        path: '/product-categories',
        name: 'productCategories',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/product-categories/product-categories'),
    },
    {
        path: '/coupons',
        name: 'coupons',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/coupons/coupons'),
    },
    {
        path: '/integrations',
        name: 'integrations',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/integrations/integrations')
    },
    {
        path: '/zoho/sync-logs',
        name: 'zoho-sync-logs',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/integrations/zoho/synclog/sync-logs')
    },
    {
        path: '/app-tokens',
        name: 'app-tokens',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/app-tokens/app-tokens')
    },
    {
        path: '/advantages',
        name: 'advantages',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/advantages/advantages')
    },
    {
        path: '/users',
        name: 'users',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/users')
    },
    {
        path: '/two-factor-settings',
        name: 'two-factor-settings',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/account/two-factor-settings')
    },
    {
        path: '/tax-rates',
        name: 'taxRates',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/tax-rates/tax-rates'),
    },
    {
        path: '/templates',
        name: 'templates',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/templates/templates'),
    },
    {
        path: '/email-templates',
        name: 'email-templates',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/email-templates/email-templates'),
    },
    {
        path: '/settings/general',
        name: 'settings-general',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/settings/general/general'),
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/index')
    },
]
